// src/utils/contact.ts
import { siteConfig } from "../data/siteConfig";

function digitsOnly(value: string): string {
  return value.replace(/[^\d]/g, "");
}

export function whatsappLink(rawNumber: string, message: string): string {
  const number = digitsOnly(rawNumber);
  return `https://wa.me/${number}?text=${encodeURIComponent(message)}`;
}

export function telegramLink(handle: string): string {
  const clean = handle.replace(/^@/, "").replace(/^https?:\/\/t\.me\//, "");
  return `https://t.me/${clean}`;
}

export function defaultContactMessage(name: string): string {
  return `Bonjour, je viens de voir votre profil sur ${siteConfig.name}. Je souhaiterais avoir plus d'informations.`;
}

export interface ShareTarget {
  label: string;
  href: string;
  icon: "whatsapp" | "telegram" | "facebook" | "x" | "link";
}

export function buildShareTargets(url: string, title: string): ShareTarget[] {
  const encodedUrl = encodeURIComponent(url);
  const encodedTitle = encodeURIComponent(title);
  return [
    {
      label: "WhatsApp",
      href: `https://wa.me/?text=${encodedTitle}%20-%20${encodedUrl}`,
      icon: "whatsapp",
    },
    {
      label: "Telegram",
      href: `https://t.me/share/url?url=${encodedUrl}&text=${encodedTitle}`,
      icon: "telegram",
    },
    {
      label: "Facebook",
      href: `https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`,
      icon: "facebook",
    },
    {
      label: "X",
      href: `https://twitter.com/intent/tweet?text=${encodedTitle}&url=${encodedUrl}`,
      icon: "x",
    },
  ];
}
